import React from 'react';
import {useTranslation} from 'react-i18next';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

/**
 * «Ver el texto»: el `prompt_text` tal cual está guardado, con los marcadores sin completar. La nota
 * explica por qué se ven las llaves: al pedirlo por la IA, Dashbo completa `{cliente}` y avisa qué
 * queda por completar.
 */
export function PromptTextModal({prompt, onClose, onCopyText}) {
    const {t} = useTranslation();
    const isOpen = Boolean(prompt);
    return (
        <Modal isOpen={isOpen} toggle={onClose} className="agp-text-modal">
            <ModalHeader toggle={onClose} closeAriaLabel={t('agency_prompts.close')}>
                {t('agency_prompts.text_modal_title')}
            </ModalHeader>
            <ModalBody>
                {prompt && (
                    <div className="agp-text-modal__body">
                        <p className="agp-text-modal__name">{prompt.title}</p>
                        <pre className="agp-text-modal__pre">{prompt.prompt_text}</pre>
                        <p className="agp-text-modal__note">{t('agency_prompts.text_modal_note')}</p>
                    </div>
                )}
            </ModalBody>
            {/* `agp-btn` y no `btn -alt`: el hover de éste aclara el naranja y deja el texto en 2,4:1. */}
            <ModalFooter>
                <button type="button" className="agp-btn -primary" onClick={() => onCopyText(prompt)}>
                    {t('agency_prompts.menu_copy_text')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
